import React, { useState, useEffect, useContext } from "react";
import * as httpService from '../services/HTTPService';
import { useLocation } from 'react-router-dom';
import ChartComponent from "./UI/StockChart";
import ReactGrid from "./React-Grid";
import { createGridColumns } from "../Utils/utils";
import SvgIcon from "./UI/SVGIcon";
import HeaderSocialLinks from "./HeaderSocialLinks";
import { modifiedTokenHash, checkIsPremium, minPremiumAmount } from "../Utils/utils";
import { isTelegramWebApp } from "../Utils/platform";
import PremiumPopop from "./UI/PremiumPopup";
import { WalletContext } from "../contexts/Wallet-context";

const CallersList = (props) => {
    const location = useLocation();
    const [resData, setResData] = useState({});
    const [isPremium, setIsPremium] = useState(checkIsPremium());
    const [isChecked, setIsChecked] = useState(false);
    const walletContext = useContext(WalletContext);
    const { wallet, setWallet } = walletContext;
    
    const socialLinksArray = [
        {
            link: '/',
            icon: '/img/social/header-social/X_gray.svg',
            class: 'tw-link',
            name: 'Twitter',
            text: 'Follow us on Twitter to stay in the loop with real-time crypto trends, Shillguard news, and engaging discussions.',
        },
        {
            link: '/',
            icon: '/img/social/header-social/Telegram_gray.svg',
            class: 'tel-link',
            name: 'Telegram',
            text: 'Connect with us on Telegram, your go-to hub for crypto calls, insightful discussions, and Shillguard announcements',
        },
        {
            link: '/',
            icon: '/img/social/header-social/Discord_gray.svg',
            class: 'dis-link',
            name: 'Discord',
            text: 'Join our Discord community for live chats, AMAs, and vibrant discussions with fellow crypto enthusiasts.',
        },
        {
            link: '/',
            icon: '/img/social/header-social/IG_gray.svg',
            class: 'in-link',
            name: 'Instagram',
            text: 'Follow us on Instagram for a visual journey into the Shillguard ecosystem.',
        },
    ]
    // TODO: replace resSocialData from backend method when it's done
    const [resSocialData, setResSocialData] = useState(socialLinksArray);
    const tName = window.location.href.split('/').pop();
    const decodedUrlTName = decodeURIComponent(tName);
    let searchParam  = location.state ? location.state.callGroup : decodedUrlTName;
    if(isTelegramWebApp() && props.name) {
        searchParam = props.name;
    }
    const CallGroupHtml = (props) => {
        let imageBase64str;
        const folderName = '/callgrimages/';
        let imgUrl = '';
        if(props.data.CallGroupImage || props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage) {
            let imgSrc = props.data.CallGroupImage || props.data.CryptoGroupImage || props.data.Image || props.data.TokenImage;
            imageBase64str = imgSrc.replace(/(\r\n|\n|\r)/gm, "");
            if(imageBase64str && imageBase64str !== '' && !imageBase64str.startsWith('http')) {
                imageBase64str = "data:image/png;base64, " + imgSrc.replace(/(\r\n|\n|\r)/gm, "");
            }
            if(imageBase64str.startsWith('http')) {
                imageBase64str = imgSrc;
            }
            if(imgSrc === null || imageBase64str.startsWith('https://shillguard-001')) {
                // TOP 5 Callers
                const imgName = imgSrc.split('/').pop();
                const img = folderName + imgName;
                imageBase64str = img;
            }
        }
        
        return (
            <div>
                {props !== undefined ? (
                    <div className={props.CryptoGroupImage ? 'flex-box custom-cell rounded-img' : 'custom-cell rounded-img'} >
                        {imageBase64str? (
                            <div className="image-name vert-line-sep">
                                <img height={46} src={imageBase64str} alt="CallGroupImage" />
                                <span>{props.data.NameOfCallGroup}</span>
                            </div>
                        ) : null}
                        {/* {props.data.Image ? (<img height={27} src={props.data.Image} alt="CallGroupImage" />) : null} */}
                    </div>
                ) : null}
            </div>
        )
    }

    const RedOrGreenColoringCallEf = (props) => {
        const label = props.data.CallEfc;
        let txtColor = '';
        if(label) {
            txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label'
        }
        return (
            <div>
                {props !== undefined ? (
                    <div className={txtColor}>{props.data.CallEfc}</div>
                ) : null}
            </div>
        )
    }

    const RedOrGreenColoringTrace= (props) => {
        const label = props.data.Trace;
        let txtColor = '';
        if(label) {
            txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label'
        }
        return (
            <div>
                {props !== undefined ? (
                    <div className={txtColor}>{props.data.Trace}</div>
                ) : null}
            </div>
        )
    }

    const RedOrGreenColoringPeak = (props) => {
        const label = props.data.Peak;
        let txtColor = '';
        if(label) {
            txtColor = label[0] === '-' ? 'red-value-label' : 'green-value-label'
        }
        return (
            <div>
                {props !== undefined ? (
                    <div className={txtColor}>{props.data.Peak}</div>
                ) : null}
            </div>
        )
    }

    const FormatDateAndTime = (props) => {
        // 2025-09-14T22:05:45
        let date = '';
        const str = props.dateString ? props.dateString.replace(' ', 'T') : '';
        let d = new Date(str);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = d.getDate();
        const formatedDay = day < 10 ? '0' + day : day;
        //const month = d.getMonth() + 1;
        let year = d.getFullYear();
        year = year.toString().slice(2, year.length)
        date = formatedDay + ' ' + monthNames[d.getMonth()] + ' ' + year;
        // "12.01.24"
        let h = d.getHours();
        let hours = h < 10 ? '0' + h : h;
        let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        let s = d.getSeconds();
        let seconds = s < 10 ? '0' + s : s;
        return (
            <div>
                <p>{date} {hours}:{minutes}:{seconds}</p>
            </div>
        );
    }

    const TimeStampHTML = (props) => {
    return (
        <div>
            {props !== undefined ? (
                <div className="flex-box custom-cell">
                    <FormatDateAndTime dateString={props.data.DateOfCall} />
                    {/* <div title="Copy Link"><SvgIcon copyText={props.data.BuyLink} /></div> */}
                </div>
            ) : null}
        </div>
    )
}

    const [colDefs, setColDefs] = useState([
        { 
            field: "NameOfCallGroup", 
            cellRenderer: CallGroupHtml, 
            headerName: 'GROUP NAME', 
            width: "auto",
            headerClass: 'i-icon',
            headerTooltip: 'The image of the group or individual influencer responsible for making the call.',
        },
        { field: "DateOfCall", 
            headerName: 'DATE', 
            cellRenderer: TimeStampHTML, 
            width: window.innerWidth  < 901 ? 160 : 350,
            headerClass: 'i-icon',
            headerTooltip: "Day/Month/Year/UTC time of the call.",
        },
        { 
            field: "CalledAtMarketCap", 
            headerName: 'CALL M.CAP',
            headerClass: 'i-icon',
            headerTooltip: 'The market capitalization of the token at the time of the call.', 
            width: window.innerWidth  < 901 ? 95 : "auto",
        },
        { 
            field: "CallEfc", 
            headerName: 'CALL EFC', 
            cellRenderer: RedOrGreenColoringCallEf, 
            headerClass: 'i-icon',
            headerTooltip: 'Maximal positive  market capitalization change  of the token in the first 15 minutes after the call was made.' ,
            width: window.innerWidth  < 901 ? 95 : "auto",
        },
        { 
            field: "Trace", 
            headerName: 'TRACE', 
            headerClass: 'i-icon',
            cellRenderer: RedOrGreenColoringTrace, 
            headerTooltip: "An ongoing assessment of the token's market capitalization movement and impact since the call.",
            width: window.innerWidth  < 901 ? 95 : "auto",
        },
        { 
            field: "PEAK", 
            cellRenderer: RedOrGreenColoringPeak, 
            headerClass: 'i-icon',
            headerTooltip: "The percentage change in price from the time of the call to the token's all-time high (ATH).",
            width: window.innerWidth  < 901 ? 95 : "auto",
        },
      ]);
    
    const populateSocialLinks = (data) => {
        let socialDataArray = [...resSocialData];
        //Twitter, Telegram, Discord, Instagram
        if(data.BioTwitter && data.BioTwitter !== '') {
            socialDataArray[0]['link'] = data.BioTwitter;
        }
        if(data.BioTelegram && data.BioTelegram !== '') {
            socialDataArray[1]['link'] = data.BioTelegram;
        }
        if(data.BioDiscord && data.BioDiscord !== '') {
            socialDataArray[2]['link'] = data.BioDiscord;
        }
        if(data.BioInstagram && data.BioInstagram !== '') {
            socialDataArray[3]['link'] = data.BioInstagram;
        }
        setResSocialData(socialDataArray);
    }
    const getData = () => {
        httpService.getTokenStatSearch(searchParam).then((res) => {
            if(res) {
                //console.log(res);
                setResData(res);
                populateSocialLinks(res);
            }
        })
    }

    const callGroupClick = (callerName) => {
        window.location.href = `/tokens/${callerName}`;
    }


    // useEffect(() => {
    //     const chartOut = document.getElementById('chart-out');
    //     if(resData && resData.TokenChain && chartOut && chartOut.children.length === 0) {
    //         createChart();
    //     }
    // }, [resData])

    useEffect(() => {
       if(wallet) {
            const walletData = typeof wallet === "string" ? JSON.parse(wallet) : wallet;
            if(parseInt(walletData.amount) > parseInt(minPremiumAmount())) {
                //const amount = JSON.parse(wallet).amount ? JSON.parse(wallet).amount : null;
                const w = typeof wallet === "string" ? JSON.parse(wallet) : wallet;
                setIsPremium(checkIsPremium(w))
            }
            else {
                setIsChecked(true);
            }
            
        }
        else {
            setIsPremium(false);
            setIsChecked(true);
        }
        
    }, [wallet, walletContext])

    const cellClickedListener =(e) => {
        if(!isTelegramWebApp()) {
            window.location.href = `/tokens/${e.data.NameOfCallGroup}`;
        }
    }
    
    useEffect(() => {
        getData();
    }, [])

    return (
        <div className="token-details callers-list-page">
            <div>
                {resData && resData.TokenName ? (
                
                <div className={!isPremium ? "hidden-data" : ""}>
                    <div className="callers-top-info">
                        {/* <h1>{resData.TokenName}<small> {resData.TokenSymbol}</small></h1> */}
                        <div className="result-list-out flex-box">
                            <div>
                                <div className="sg-outline">
                                    <div className="tkn-top-info flex-box">
                                        <div>
                                            <img src={resData.TokenImage} alt="token" />
                                        </div>
                                        <div style={{"flex": "1"}}>
                                            <div className="flex-box token-heading">
                                                <h3 style={{'margin': '0'}}>{resData.TokenName}</h3>
                                                <div className="right">
                                                    <div className="flex-box tkn-buttons" style={{"gap": "10px"}}>
                                                        <div>
                                                            <a type="button" href={resData.BuyLink} target="_blank" rel="noreferrer">
                                                                <img src="img/sgt-buy-icon.png" alt="buy" />
                                                            </a>
                                                        </div>
                                                        <div className="a-center">
                                                            <a type="button" href={resData.TokenLink} target="_blank" rel="noreferrer">
                                                                <img src="img/sgt-scan-icon.png" alt="scan" />
                                                            </a>
                                                        </div>
                                                        <div className="a-right">
                                                            <a type="button" href={resData.TokenChart} target="_blank" rel="noreferrer">
                                                                <img src="img/sgt-chart-icon.png" alt="chart" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="h-10"></div>
                                            <span className="inter-medium-16" style={{"display": "flex", "alignItems": "center", "gap": "5px"}}> 
                                                {resData.TokenSymbol}
                                                <span style={{"margin" : "0 8px", "fontSize": "12px"}} className="inter-medium-16 gray-txt"> | </span>
                                                {resData.TokenChain} 
                                                <span className="inter-medium-16 gray-txt" style={{"margin" : "0 8px", "fontSize": "12px"}}> | </span>
                                                <span className="inter-medium-16">{modifiedTokenHash(resData.TokenHash)} <span title="Copy Link"><SvgIcon copyText={resData.TokenHash} /></span></span>
                                                <span className="tkn-pr-usd inter-medium-16" style={{"marginLeft": "auto"}}> {resData.PriceUSD} </span>
                                            </span>
                                        </div>
                                    </div>
                                    <ul className='result-list'>
                                        <li>
                                            <div className="gradient-b">
                                                <div>
                                                    <span className="inter-medium-16 gray-txt">M.Cap</span>
                                                    <p>{resData.CurrentMarketCap}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="gradient-b">
                                                <div>
                                                    <span className="inter-medium-16 gray-txt">Liquidity</span>
                                                    <p>{resData.Liquidity}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="gradient-b">
                                                <div>
                                                    <span className="inter-medium-16 gray-txt">M.Cap ATH</span>
                                                    <p>{resData.ATXMarketCap}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="gradient-b">
                                                <div>
                                                    <span className="inter-medium-16 gray-txt">Volume</span>
                                                    <p>{resData.Volume}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="gradient-b">
                                                <div>
                                                    <span className="inter-medium-16 gray-txt">Total Calls</span>
                                                    <p>{resData.TotalCalls}</p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="sg-outline">
                                    <p className="inter-medium-16 gray-txt">
                                        <img src="img/sgt-popup-gray.png" alt="popup" style={{"marginRight": "10px"}} />
                                       {resData.BioToken}
                                    </p>
                                    <div className="flex-box align-right soc">
                                        <HeaderSocialLinks links={resSocialData} />
                                        <a type="button" className="inter-bold-16 right update-bio-btn" href={resData.UpdateBioButtonLink} target="_blank" rel="noreferrer">Update bio</a>
                                    </div>
                                </div>
                            </div>
                            <div id="chart-out">
                                {/* <ChartComponent /> */}
                                <div className="chart-out">
                                    <iframe src={`https://embedded.dexview.com/${resData.TokenChain}/${resData.TokenHash}`}  />
                                    {/* <iframe src={`https://www.dextools.io/widget-chart/en/${resData.TokenChain}/pe-light/${resData.TokenHash}`}  /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="callers-stat">
                        <h3>Best Calls</h3> 
                        <table style={{width: '100%'}} className="callers-stat-table">
                            <tbody>
                                {resData.TokenStatisticData && resData.TokenStatisticData.length > 0 ? (
                                    <>
                                        {resData.TokenStatisticData.map((item, i) => {
                                            return (
                                                <tr key={i} onClick={() => callGroupClick(item.NameOfCallGroup)}>
                                                    <td className="td-img"><span className="call-group-img"><img alt="Call group image" src={`/callgrimages/${item.CallGroupImage.split('/').pop()}`} /></span></td>
                                                    <td>{item.NameOfCallGroup} <br />{item.DateOfCall}</td>
                                                    <td>Called at <br />Reached</td>
                                                    <td>{item.CalledAtMarketCap} <br />{item.ReachedMarketCap}</td>
                                                    <td>{item.Peak}</td>
                                                </tr>
                                            )
                                        })}
                                    </>
                                ) : null}
                            </tbody>
                        </table>
                    </div> */}
                    <>
                        {isChecked && !isPremium ? (
                            <PremiumPopop />
                        ) : null}
                        <div className="h-20"></div>
                        <div className="data-filter">
                            <div className="flex-box">
                                <div className="filter-title">
                                    <h2 className="inter-bold-16">
                                        <img src="/img/sgt-group-calls.png" alt="filter title"/>
                                        Group Calls
                                    </h2>
                                </div>
                                <div className="data-filters">
                                </div>
                            </div>
                        </div>
                        
                        {resData.TokenStatisticData && resData.TokenStatisticData.length > 0 ? (
                            <ReactGrid 
                                mobileRowHeight={92}
                                tooltipInteraction={true} 
                                columns={colDefs} 
                                sortable={true} 
                                rowData={resData.TokenStatisticData} 
                                errorMessage={''} 
                                // defaultColDef={{'flex': 1}} 
                                cellClickedListener={cellClickedListener}
                            />
                        ) : null}
                    </>
                    
                </div>
                ) : null}
            </div>
        </div>
    )
}

export default CallersList;